import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { apiErrorClear } from '../../../../global/ducks/base-api';
import { setDocumentUploadStatus } from '../personal-info/document-upload-slice';
import { DemographicsContext } from '../../../../global/models/demographics-model';
import { useQuery } from '../../../../global/hooks/useQuery';
import { TcsmStates } from '../../../../root/tcsm-model';
import { MyCPGMidYearProps } from '../mycpg-midyear/models/mycpg-midyear-epi-props';
import { QualifyingEventForm } from './qualifying-event-form';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { AccountInfoRoutes } from '../../constants/routes';
import { useMyCPGMidYearSettings } from '../mycpg-midyear/hooks/useMyCPGMidyearSettings';
import { TcsmAppConfigs } from '../../../../global/models/configuration-models';

interface Props {
	appConfig: TcsmAppConfigs
}
function QualifyingEventPage(props: Props) {
	const { appConfig } = props;
	const app = useContext(DemographicsContext);
	const midYearSettings = useSelector<TcsmStates, MyCPGMidYearProps>(state => state?.epiProps?.myCpgMidyearSettingsState?.epiContent);
	const eventType = useQuery()?.get('eventType');
	const dispatch = useDispatch();
	const model = midYearSettings?.qualifyingEventPageContents?.find(a => a.eventType === eventType);
	const myCpgRoot = useBasePath(AccountInfoRoutes.MyCpgRoot);
	const midyearLoaded = useMyCPGMidYearSettings(appConfig.myCpgMidYearSettingsId);

	useEffect(() => {
		dispatch(apiErrorClear());
		dispatch(setDocumentUploadStatus(false, app));
	}, []);

	if (!midyearLoaded) {
		return <LoadingCircle />;
	}

	if (!model) {
		return <Redirect to={myCpgRoot} />;
	}

	return (
		<QualifyingEventForm model={model} />
	);
}

export default QualifyingEventPage;